export default __webpack_public_path__ + "text_layer_builder-98dffc3a2a87359ef6e2b63c87d62a80.css";